export default __webpack_public_path__ + "851bdf340d1d85c1f7186d311f3d874f.svg";